/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentMini = _interopRequireDefault(require("moment-mini"));
var _classnames = _interopRequireDefault(require("classnames"));
var _timeHelper = require("../utils/timeHelper");
var _Program = _interopRequireDefault(require("./Program"));
var _ChannelLane = _interopRequireDefault(require("./ChannelLane"));
var _ProgramLane = _interopRequireDefault(require("./ProgramLane"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultComponents = {
  ChannelLane: _ChannelLane["default"],
  ProgramLane: _ProgramLane["default"],
  Program: _Program["default"]
};

/**
 * A tile for showing the actual TV listings information
 * in the Program Guide grid for a given coordinate.
 *
 * The tile is given a channel range and time range based
 * on the grid coordinate it belongs to.
 *
 * Based on the ranges it renders channel lanes with program components
 * positioned based on their start and end time.
 *
 * Also supporting key navigation if used with @accedo/vdkweb-navigation and
 * focusable Program components.
 *
 * @param {object} props See propTypes
 * @returns {ProgramGuideTile} A ProgramGuideTile component
 */
var ProgramGuideTile = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ProgramGuideTile, _React$PureComponent);
  var _super = _createSuper(ProgramGuideTile);
  function ProgramGuideTile() {
    _classCallCheck(this, ProgramGuideTile);
    return _super.apply(this, arguments);
  }
  _createClass(ProgramGuideTile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        animated = _this$props.animated,
        channels = _this$props.channels,
        components = _this$props.components,
        componentsProps = _this$props.componentsProps,
        currentTime = _this$props.currentTime,
        draggable = _this$props.draggable,
        endTime = _this$props.endTime,
        firstChannelIndex = _this$props.firstChannelIndex,
        getNavForProgram = _this$props.getNavForProgram,
        height = _this$props.height,
        lastChannelIndex = _this$props.lastChannelIndex,
        metadata = _this$props.metadata,
        onClickProgram = _this$props.onClickProgram,
        startTime = _this$props.startTime,
        theme = _this$props.theme,
        vertical = _this$props.vertical,
        width = _this$props.width,
        rtl = _this$props.rtl,
        epgEndTime = _this$props.epgEndTime,
        epgStartTime = _this$props.epgStartTime;
      var _defaultComponents$co = _objectSpread(_objectSpread({}, defaultComponents), components),
        ChannelLane = _defaultComponents$co.ChannelLane,
        ProgramLane = _defaultComponents$co.ProgramLane,
        Program = _defaultComponents$co.Program;
      var nrOfChannels = lastChannelIndex - firstChannelIndex || 1;
      var laneHeight = vertical ? height : height / nrOfChannels;
      var laneWidth = vertical ? width / nrOfChannels : width;
      var animation = animated ? {
        speed: 200
      } : {
        disabled: true
      };
      var minuteToPixelRatio = (vertical ? height : width) / (0, _timeHelper.msToMinutes)(endTime - startTime);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(theme.channelListTile, _defineProperty({}, theme.animated, animated)),
        style: {
          width: width,
          height: height
        }
      }, channels.map(function (channel, channelIndex) {
        return /*#__PURE__*/_react["default"].createElement(ChannelLane, {
          key: channel.channelId,
          channelIndex: firstChannelIndex + channelIndex,
          height: laneHeight,
          metadata: metadata,
          vertical: vertical,
          width: laneWidth
        }, /*#__PURE__*/_react["default"].createElement(ProgramLane, {
          animation: animation,
          channelIndex: firstChannelIndex + channelIndex,
          currentTime: currentTime,
          epgEndTime: epgEndTime,
          epgStartTime: epgStartTime,
          height: laneHeight,
          metadata: metadata,
          minuteToPixelRatio: minuteToPixelRatio,
          rtl: rtl,
          startTime: startTime,
          vertical: vertical,
          width: laneWidth
        }, channel.programs.map(function (program, programIndex) {
          var programNav = getNavForProgram ? getNavForProgram(program, programIndex, channelIndex, rtl) : {};
          var ongoing = currentTime && (0, _momentMini["default"])(currentTime).isBetween((0, _momentMini["default"])(program.startTime), (0, _momentMini["default"])(program.endTime));
          var handleProgramClick = function handleProgramClick() {
            return onClickProgram(program, channel);
          };
          var programProps = componentsProps.Program || {};
          return /*#__PURE__*/_react["default"].createElement(Program, _extends({}, program, {
            key: program.id,
            draggable: draggable,
            id: program.id,
            nav: programNav,
            onClick: onClickProgram && handleProgramClick,
            ongoing: ongoing,
            rtl: rtl,
            title: program.title || program.mediaId
          }, programProps));
        })));
      }));
    }
  }]);
  return ProgramGuideTile;
}(_react["default"].PureComponent);
_defineProperty(ProgramGuideTile, "displayName", 'ProgramGuideTile');
ProgramGuideTile.propTypes = {
  /** If the tile should apply a fade in animation */
  animated: _propTypes["default"].bool,
  /**
   * Handler for changing the global focus in order
   * for the tile to decide the current focus element.
   * Will be passed a focus ID when triggered.
   */
  changeFocus: _propTypes["default"].func,
  channels: _propTypes["default"].array,
  /** Overridable inner components if you want to bring your own */
  components: _propTypes["default"].shape({
    ChannelLane: _propTypes["default"].elementType,
    Program: _propTypes["default"].elementType,
    ProgramLane: _propTypes["default"].elementType
  }),
  /** Extra props passed to the components */
  componentsProps: _propTypes["default"].shape({
    Program: _propTypes["default"].object
  }),
  /** The tiles coordinate in the datagrid */
  coordinate: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),
  currentTime: _propTypes["default"].number,
  /** Data object for the tile containing TV listings information  */
  data: _propTypes["default"].object,
  draggable: _propTypes["default"].bool,
  endTime: _propTypes["default"].number,
  epgEndTime: _propTypes["default"].number,
  epgStartTime: _propTypes["default"].number,
  firstChannelIndex: _propTypes["default"].number,
  getNavForProgram: _propTypes["default"].func,
  /** Height of the tile */
  height: _propTypes["default"].number,
  /**
   * If this tile's coordinate is the marker coordinate
   * in the datagrid.
   */
  isSelected: _propTypes["default"].bool,
  lastChannelIndex: _propTypes["default"].number,
  metadata: _propTypes["default"].object,
  /** Click handler for a program cell */
  onClickProgram: _propTypes["default"].func,
  /**
   * Handler for datagrid movement downwards.
   * ```onDown(navigationData, distance)```
   */
  onDown: _propTypes["default"].func,
  /**
   * Handler for datagrid movement to the left.
   * ```onLeft(navigationData, distance)```
   */
  onLeft: _propTypes["default"].func,
  /**
   * Handler for datagrid movement:
   * ```onMoveTo(coordinate, navigationData)```
   *
   * Will notify which coordinate to move to
   * and any relevant data the target coordinate
   * needs to handle focus properly for the transition.
   */
  onMoveTo: _propTypes["default"].func,
  /**
   * Handler for datagrid movement to the right.
   * ```onRight(navigationData, distance)```
   */
  onRight: _propTypes["default"].func,
  rtl: _propTypes["default"].bool,
  startTime: _propTypes["default"].number,
  /** Classname API for theming */
  theme: _propTypes["default"].shape({
    animated: _propTypes["default"].string,
    channelListTile: _propTypes["default"].string
  }),
  /**
   * If the programs are being layed out
   * vertically in a channel lane
   */
  vertical: _propTypes["default"].bool,
  /** Width of the tile */
  width: _propTypes["default"].number
};
ProgramGuideTile.defaultProps = {
  animated: true,
  componentsProps: {},
  theme: {}
};
var _default = ProgramGuideTile;
exports["default"] = _default;